import React, { useState, useEffect } from "react";
import { Formik } from "formik";
import { useHistory } from "react-router-dom";

// component
import AnimationLoading from "../../../components/Animationloading";
import CustomButton from "../../../components/CustomButton";
import { COLOR_WHITE, LINEAR_GRADIENT_BG, USER_KEY } from "../../../const";
import {
  errorSwal,
  successDeleteSwal,
  successSwal,
  successUpdateSwal,
  warningSwal,
} from "../../../helper/sweetalert";
import PaginationHelper from "../../../components/PaginationHelper";
import EmptyComponent from "../../../components/EmptyComponent";

// apollo
import { useLazyQuery, useMutation } from "@apollo/client";
import {
  CHOOSE_PRINTER,
  CREATE_PRINTER,
  DELETE_PRINTER,
  UPDATE_PRINTER,
} from "../../../apollo/printer/Mutaion";
import { GET_PRINTERS } from "../../../apollo/printer/Query";

// icon
import DoneAllIcon from "@mui/icons-material/DoneAll";
import { RiDeleteBin6Line } from "react-icons/ri";
import { MdOutlineBorderColor } from "react-icons/md";

// react bootrap
import { Form, Modal, Spinner, Table, Button } from "react-bootstrap";
import ComfirmModal from "../../../components/ComfirmModal";
import { ReactIcons } from "../../../icons";

function Printer() {
  const history = useHistory();
  const [printer, setPrinter] = useState();
  const shopId = JSON.parse(localStorage.getItem(USER_KEY))?.data?.shop?.id;
  const [selectedOption, setSelectedOption] = useState("");
  const [printerTotal, setPrinterTotal] = useState();
  const [showDelete, setShowDelete] = useState(false);
  const [Delete, setDelete] = useState("");
  const { _limit, _skip } = PaginationHelper();
  const [showBrand, setShowBrand] = useState(false);
  const [showSelectPinter, setShowSelectPrinter] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [editIndex, setEditIndex] = useState();
  const [editData, setEditData] = useState({});

  // ==========> useLazyQuery And useMutation <==========

  const [loadPrinter, { data: getPrinter, loading }] = useLazyQuery(
    GET_PRINTERS,
    { fetchPolicy: "network-only" }
  );
  const [createprinter, { loading: loadingCreate }] =
    useMutation(CREATE_PRINTER);
  const [deleteprinter, { loading: loadingDelete }] =
    useMutation(DELETE_PRINTER);
  const [updateprinter, { loadingd: loadingUpdate }] =
    useMutation(UPDATE_PRINTER);
  const [chooseprinter, { loading: loadingChoosePrinter }] =
    useMutation(CHOOSE_PRINTER);

  // ==========> useEffect <==========

  useEffect(() => {
    _fetchPrinter();
  }, []);

  useEffect(() => {
    if (getPrinter) {
      setPrinter(getPrinter?.printers?.data);
      setPrinterTotal(getPrinter?.printers?.total);
    }
  }, [getPrinter]);


  const _fetchPrinter = async () => {
    await loadPrinter({
      variables: {
        where: {
          shop: shopId,
          isDeleted: false,
        },
      },
    });
  };

  // ========== update ExchangeRate ==========

  const _updatePrinter = async () => {
    try {
      if (loadingUpdate) return;
      await updateprinter({
        variables: {
          orderBy: "createdAt_DESC",
          where: {
            id: editData?.id,
          },
          data: {
            ip: editData?.ip,
            name: editData.name,
          },
        },
      });

      setIsEdit(false);
      setEditIndex();
      setEditData({});
      successUpdateSwal("ເເກ້ໄຂຂໍ້ມູນສຳເລັດ");
      _fetchPrinter();
    } catch (err) {
      warningSwal("ປີ່ນເຕີ້ນີ້ມີຢູ່ແລ້ວ");
      console.log("error creating todo:", err);
    }
  };

  // <=============== create Printer =================>

  const _createProduct = async (values) => {
    if (!values.name) {
      warningSwal("ກະລຸນາເພີ່ມປີນເຕີ້...");
      return;
    }
    try {
      if (loadingCreate) return;
      await createprinter({
        variables: {
          data: {
            ...values,
          },
        },
      });

      _fetchPrinter();
      successSwal("ເພີ່ມປີນເຕີ້ສຳເລັດ");
      setShowBrand(false);
    } catch (err) {
      warningSwal("ປີ່ນເຕີ້ນີ້ມີຢູ່ແລ້ວ");
      // console.log('error creating todo:', err)
    }
  };

  // <=============== shoose Printer =================>

  const _choosePrinter = async (item) => {

    try {
      if (loadingChoosePrinter) return;
      await chooseprinter({
        variables: {
          where: {
            id: item?.id,
          },
          data: {
            status: true,
          },
        },
      });
      _fetchPrinter();
      successSwal("ເລືອກປີນເຕີ້ສຳເລັດ");
      setShowSelectPrinter(false);
    } catch (error) {
      // errorSwal('ລາຍການສິນຄ້ານີ້ມີຢູ່ແລ້ວ')
      console.log('error printer:', error)
    }
  };

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };

  // <=============== fuction delete =================>
  const handleShowDelete = (id, name) => {
    setDelete({ name, id });
    setShowDelete(true);
  };
  const _confirmeDelete = async () => {
    try {
      if (loadingDelete) return;
      await deleteprinter({
        variables: {
          where: {
            id: Delete?.id,
          },
        },
      });
      _fetchPrinter();
      successDeleteSwal("ລົບສຳເລັດ");
      setShowDelete(false);
    } catch (err) {
      errorSwal("ການລົບຂໍ້ມູນບໍ່ສຳເລັດ !");
    }
  };

  // <=============== Edit in box =================>
  const onEditData = async (data, index) => {
    setIsEdit(true);
    setEditIndex(index);
    setEditData(data);
  };

  const onCancelEditData = async () => {
    setIsEdit(false);
    setEditIndex();
    setEditData({});
  };

  return (
    <React.Fragment>
      <div
        style={{
          padding: "15px",
        }}>
        <div
          style={{
            backgroundColor: "#FFFFFF",
            padding: "20px",
            height: "100vh",
            overflow: "auto",
          }}>
          <div>
            <h3>
              ປິນເຕີ້
            </h3>
            <p>ລາຍການປິນເຕີ້ </p>
          </div>

          <div style={{ display: "flex", gap: 7, justifyContent: 'end', width: '100%' }}>
            <CustomButton
              width="165px"
              height="46px"
              title=" ເລືອກປີນເຕີ້"
              background="green"
              icon={<ReactIcons.BsFillCheckCircleFill size={20} />}
              borderRadius="8px"
              onClick={() => setShowSelectPrinter(true)}
            />


            <CustomButton
              width="135px"
              background={LINEAR_GRADIENT_BG}
              height="46px"
              title="ເພີ່ມ"
              icon={<ReactIcons.MdAdd style={{ fontSize: 24 }} />}
              borderRadius="8px"
              onClick={() => setShowBrand(true)}
            />
          </div>

          {/* table */}
          {loading ? (
            <AnimationLoading />
          ) : (
            <>
              {printer?.length > 0 ? (
                <Table
                  responsive
                  style={{
                    marginTop: "20px",
                    borderCollapse: "collapse",
                    width: "100% ",
                  }}>
                  <thead
                    style={{
                      background: "#1F3A60",
                      borderRadius: " 8px 8px 0px 0px",
                      color: "#FFFFFF",
                    }}>
                    <tr>
                      <th>ລ/ດ</th>
                      <th>ສະຖານະ</th>
                      <th>ຊື່ປິນເຕີ້</th>
                      <th>ຂະໜາດ</th>
                      <th>IP Address</th>
                      <th>ປະເພດ</th>
                      <th style={{ textAlign: 'right' }}>ຈັດການ</th>
                    </tr>
                  </thead>
                  <tbody>
                    {printer?.map((p, index) => {
                      return (
                        <tr
                          key={p + index}
                          style={{
                            alignItems: "center",
                            whiteSpace: "nowrap",
                            color: p?.status === false ? "" : "green",
                          }}>
                          <td style={{ paddingTop: "1rem" }}>{index + 1}</td>
                          <td style={{ paddingTop: "1rem" }}>
                            {p?.status === false ? (
                              "ບໍ່ໄດ້ໃຊ້ງານ"
                            ) : (
                              <DoneAllIcon />
                            )}
                          </td>
                          <td style={{ paddingTop: "1rem" }}>
                            {isEdit == true && editIndex === index ? (
                              <Form.Control
                                type="text"
                                name="name"
                                onChange={(e) => {
                                  let _data = editData;
                                  _data = {
                                    ...editData,
                                    name: e?.target?.value,
                                  };
                                  setEditData(_data);
                                }}
                                value={editData?.name}
                                placeholder="ຊື່ປີນເຕີ້..."
                                style={{
                                  border: editData?.name ? "" : "solid 1px red",
                                }}
                              />
                            ) : (
                              <div>{p?.name}</div>
                            )}
                          </td>
                          <td style={{ paddingTop: "1rem" }}>{p?.width}</td>
                          <td style={{ paddingTop: "1rem" }}>
                            {isEdit == true && editIndex === index ? (
                              <Form.Control
                                type="text"
                                name="ip"
                                onChange={(e) => {
                                  let _data = editData;
                                  _data = {
                                    ...editData,
                                    ip: e?.target?.value,
                                  };
                                  setEditData(_data);
                                }}
                                value={editData?.ip}
                                placeholder="ຊື່IP..."
                                style={{
                                  border: editData?.name ? "" : "solid 1px red",
                                }}
                              />
                            ) : (
                              <div>{p?.ip}</div>
                            )}
                          </td>
                          <td style={{ paddingTop: "1rem" }}>{p?.type}</td>
                          {isEdit == true && editIndex === index ? (
                            <td align="right">
                              <div style={{ display: "flex", width: '100%' }}>
                                <CustomButton
                                  width="auto"
                                  color="#3058A6"
                                  background="#F1F1F1"
                                  borderRadius="8px"
                                  title="ຍົກເລີກ"
                                  onClick={() => onCancelEditData()}
                                />
                                &ensp;
                                <CustomButton
                                  width="auto"
                                  borderRadius="8px"
                                  title={loadingUpdate ? <Spinner /> : "ບັນທືກ"}
                                  onClick={() => _updatePrinter()}
                                />
                              </div>
                            </td>
                          ) : (
                            <td align="right">
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  width: '100%'
                                }}>
                                <CustomButton
                                  width="auto"
                                  borderRadius="8px"
                                  textalign="center"
                                  border="1px solid #3C169B"
                                  title="ເເກ້ໄຂ"
                                  color="#3C169B"
                                  background="#F7F7F7"
                                  icon={
                                    <MdOutlineBorderColor
                                      style={{
                                        color: "#3C169B",
                                        fontSize: "20px",
                                      }}
                                    />
                                  }
                                  onClick={() => onEditData(p, index)}
                                />
                                &ensp;
                                <CustomButton
                                  width="auto"
                                  margin="0"
                                  title=" ລົບ"
                                  border="1px solid #DC2626"
                                  borderRadius="8px"
                                  background="#F7F7F7"
                                  color="#DC2626"
                                  icon={
                                    <RiDeleteBin6Line
                                      style={{
                                        color: "#D21C1C",
                                        fontSize: "20px",
                                      }}
                                    />
                                  }
                                  onClick={() =>
                                    handleShowDelete(p?.id, p?.name)
                                  }
                                />
                              </div>
                            </td>
                          )}
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              ) : (
                <div
                  style={{
                    fontSize: "24px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    // height: "100%",
                    // background:"red",
                    color: "#6B7280",
                    fontWeight: "400",
                  }}>
                  <EmptyComponent />
                  <p>ຍັງບໍ່ມີປິນເຕີ້ກະລຸນາໄປເພີ່ມປິນເຕີ້ກ່ອນ !!!</p>
                </div>
              )}
            </>
          )}
          {/* end table */}
        </div>
      </div>

      <ComfirmModal
        showConfirmModal={showDelete}
        handleCancel={() => setShowDelete(false)}
        handleConfirm={
          _confirmeDelete
        }
        title="ແຈ້ງເຕືອນ"
        text={
          `ທ່ານຕອ້ງການລົບຂໍ້ມູນ` + ` ${Delete?.name}` + ` ນີ້ເເທ້ບໍ່!`
        }
      />

      {/* create printer */}

      <Modal show={showBrand} onHide={() => setShowBrand(false)}>
        <Modal.Header closeButton>
          <Modal.Title>ເພີ່ມປີນເຕີ້</Modal.Title>
        </Modal.Header>
        <Formik
          enableReinitialize={true}
          initialValues={{
            name: "",
            type: "",
            ip: "",
            width: "",
            shop: shopId,
          }}
          validate={(values) => {
            const errors = {};
            if (!values.name) {
              errors.name = "-";
            }
            if (!values.width) {
              errors.width = "-";
            }
            if (!values.type) {
              errors.type = "-";
            }
            if (!values.ip) {
              errors.ip = "-";
            }

            return errors;
          }}
          onSubmit={(values, { setSubmitting }) => {
            _createProduct(values).then((e) => { });
          }}>
          {({
            values,
            errors,
            touched,
            handleChange,
            setFieldValue,
            handleBlur,
            handleSubmit,
            isSubmitting,
            /* and other goodies */
          }) => (
            <>
              <Modal.Body>
                <Form.Label>
                  ຊື່ປິນເຕີ້<span style={{ color: "red" }}>*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.name}
                  placeholder="ຊື່ປິນເຕີ້..."
                  isInvalid={errors?.name}
                />
                <Form.Label>
                  ຂະໜາດເຈ້ຍ <span style={{ color: "red" }}>*</span>
                </Form.Label>
                <Form.Control
                  as="select"
                  name="width"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values?.width}
                  isInvalid={errors?.width}>
                  <option value="" disabled>
                    -ເລືອກຂະໜາດເຈ້ຍ-
                  </option>
                  <option value="80mm">80mm</option>
                  <option value="58mm">58mm</option>
                </Form.Control>
                <Form.Label className="mt-2">ປະເພດປິນເຕີ</Form.Label>
                <Form.Select
                  name="type"
                  onChange={(e) => {
                    handleChange(e);
                    if (e.target.value === "USB") {
                      setFieldValue("ip", "192.168.1.1");
                    } else {
                      setFieldValue("ip", "");
                    }
                  }}
                  onBlur={handleBlur}
                  value={values?.type}
                  isInvalid={errors?.type}>
                  <option value="" disabled>
                    -ເລືອກປະເພດປິນເຕີ-
                  </option>
                  <option value="ETHERNET">ETHERNET</option>
                  <option value="BLUETOOTH">BLUETOOTH</option>
                  <option value="USB">USB - (coming soon)</option>
                </Form.Select>
                {values.type != "USB" ? (
                  <>
                    {" "}
                    <Form.Label className="mt-2">IP or BT</Form.Label>
                    <Form.Control
                      type="text"
                      name="ip"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values?.ip}
                      placeholder="192.168.x.x..."
                      isInvalid={errors?.ip}
                    />
                  </>
                ) : (
                  ""
                )}
              </Modal.Body>
              <Modal.Footer>
                <CustomButton
                  title="ຍົກເລີກ"
                  width="100px"
                  background="#A9B3BD"
                  borderRadius="8px"
                  onClick={() => setShowBrand(false)}
                />
                &ensp;
                <CustomButton
                  title={loadingCreate ? <Spinner /> : "ບັນທຶກ"}
                  width="100px"
                  borderRadius="8px"
                  onClick={() => handleSubmit()}
                />
              </Modal.Footer>
            </>
          )}
        </Formik>
      </Modal>

      {/* Select Use Printer */}

      <Modal show={showSelectPinter} onHide={() => setShowSelectPrinter(false)}>
        <Modal.Header closeButton>
          <Modal.Title>ເລືອກປີນເຕີ້ {loadingChoosePrinter && <Spinner size="sm" color="success" />} </Modal.Title>
        </Modal.Header>
        <Modal.Body>

          {printer?.map((item, index) => (
            <Button
              onClick={() => _choosePrinter(item)}
              key={index}
              variant={item?.status ? "success" : "outline-secondary"}
              style={{
                textAlign: 'left',
                width: '100%',
                marginBottom: 3,
                padding: 16,
                position: 'relative',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
              }}
            >
              <span>
                {item?.name} ({item?.ip})
              </span>
              <span style={{ color: item?.status ? COLOR_WHITE : 'gray' }}>
                {item?.status ? <ReactIcons.FaCheckCircle style={{ fontSize: 25 }} /> : <ReactIcons.FaInfo style={{ fontSize: 25 }} />}
              </span>
            </Button>
          ))}
          {/* <Modal.Footer>
                  <CustomButton
                    title={loadingChoosePrinter ? <Spinner /> : "ບັນທຶກ"}
                    width="100px"
                    borderRadius="8px"
                  />
                </Modal.Footer> */}
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
}

export default Printer;
